import PropTypes from "prop-types";
import HighchartsReact from "highcharts-react-official";
import Highcharts from 'highcharts'
import { useArgonController } from "context";
import { useEffect, useState } from "react";
import colorsDark from "assets/theme-dark/base/colors";
import colors from "assets/theme/base/colors";

const ProgresRealisasiChartLine = ({ data, title, percent = false }) => {
    const [controller] = useArgonController();
    const { darkMode } = controller;

    const [options, setOptions] = useState({})

    useEffect(() => {
        setOptions({
            chart: {
                type: 'spline',
                backgroundColor: darkMode && colorsDark.background.dark
            },
            title: {
                text: title,
                style: {
                    color: darkMode ? colorsDark.text.main : colors.text.main
                }
            },
            xAxis: {
                categories: [
                    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
                ],
                accessibility: {
                    description: 'Months of the year'
                },
                labels: {
                    style: {
                        color: darkMode ? colorsDark.text.main : colors.text.main
                    },
                }
            },
            yAxis: {
                title: {
                    text: 'Capaian',
                    style: {
                        color: darkMode ? colorsDark.text.main : colors.text.main
                    }
                },
                labels: {
                    format: '{value:,.f}',
                    style: {
                        color: darkMode ? colorsDark.text.main : colors.text.main
                    }
                }
            },
            tooltip: {
                crosshairs: true,
                shared: true,
                headerFormat: '<span style="font-size:11px">{point.x}</span><br>',
                pointFormat: percent ? '<span style="color:{point.color}">{series.name}</span>: <b>{point.y:,.2f}%</b></br>' : '<span style="color:{point.color}">{series.name}</span>: <b>{point.y:,.2f}</b></br>'
            },
            plotOptions: {
                spline: {
                    marker: {
                        radius: 4,
                        lineColor: '#666666',
                        lineWidth: 1
                    }
                },
            },
            series: data
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, darkMode])

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
        />
    )
}

ProgresRealisasiChartLine.propTypes = {
    data: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
    percent: PropTypes.bool
}

export default ProgresRealisasiChartLine